<div class="header-container">
  <img src="../../../../assets/quotation-dashboard/KIKBLOX Reverse logo-01 1.png" alt="Logo" class="header-logo" />
  <h1 class="header-title">Quotation Management System</h1>
  <div class="header-date-time">{{ currentDateTime }}</div>
</div>